<template>
  <div id="contenedorBeneficios" class="contenedor">
    <div v-show="cargando" class="card indicador-carga">
      <div class="card-body card-separador">
        <div class="spinner-border" role="status">
          <span class="sr-only">Cargando...</span>
        </div>
      </div>
    </div>
    <template v-if="!cargando">
      <div v-show="cantidad <= 0" class="alert alert-primary info-sin-elementos" role="alert">
        <p class="principal">No se encontraron beneficios</p>
        <p v-if="infoSinResultados" class="extra">{{ infoSinResultados }}</p>
      </div>
      <div v-show="cantidad > 0" id="tarjetas" class="box-cards-moda">
        <div class="contenedor-individual-card" v-for="ben in beneficios" v-bind:key="ben.id"
          @click="clickBeneficio(ben)">
          <div :class="{ opacidad: !ben.habilitado }" class="card-descuento">
            <div class="contenedor-img-desc">
              <vue-load-image>
                <img slot="image" :src="CarpetaLogos + ben.urlLogo + IndicadorMiniatura" alt="Logo del beneficio" />
                <!-- Indicador de carga de imagen -->
                <div slot="preloader">
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </div>
              </vue-load-image>
            </div>
            <a class="card-linc-desc">
              <div class="corazon" v-bind:style="{ color: ColorModa }">
                <h5 v-bind:style="{
                  'font-size': fontSizeLabel(ben.porcentajeDescuento)
                }">
                  {{ ben.porcentajeDescuento }}
                </h5>
                <font-awesome-icon :icon="Icons.APP_ICON_4" />
              </div>
              <div class="sombra-corazon">
                <font-awesome-icon :icon="Icons.APP_ICON_4" />
              </div>
              <div class="contenedor-info" :class="{ 'contenedor-info--hover': ben.habilitado }">
                <button>
                  <template v-if="ben.suscripto"> Suscripto! </template>
                  <template v-else>
                    Info
                    <font-awesome-icon class="icono" :icon="Icons.ABRIR_MODAL" />
                  </template>
                </button>
              </div>
            </a>
          </div>
        </div>
      </div>
    </template>
    <!-- Por alguna razón no funciona si está dentro de template -->
    <div v-show="!cargando" id="contenedor-paginacion">
      <Paginacion :cantidad="cantidad" :cantidadPorPagina="BeneficiosPorPagina" v-on:pagina-cambiada="paginaCambiada">
      </Paginacion>
    </div>
  </div>
</template>
<script>
import { environment } from "../environments/environment";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { mapState } from "vuex";
import VueLoadImage from "vue-load-image";

import {
  Carpetas,
  Icons as IconConstants,
  Paginacion as PaginacionConstantes,
} from "../constants";
import Paginacion from "./Paginacion";
import { Util } from "../util";

const CLICK_BENEFICIO_EVENT = "click-beneficio";

export default {
  name: "Tarjetas",
  components: {
    FontAwesomeIcon,
    VueLoadImage,

    Paginacion,
  },
  props: {
    busqueda: Object,
    // Si está en verdadero, no se realizarán cargas automáticas
    // Ejemplo en el mounted hook o cuando cambia la búsqueda
    cargaManual: Boolean,
    // Información extra mostrada cuando no se encontraron resultados
    infoSinResultados: String,
    location: Object,
    service: Function,
    subcategoria: Object,
  },
  data() {
    return {
      /** Cantidad de beneficios en el servidor (usualmente hay más de los que se muestran en el cliente) */
      cantidad: 0,
      /** Usado para mostrar el indicador de carga */
      cargando: true,
      idUsuario: null,
      numeroDePagina: 1,
      token: null,
    };
  },
  computed: {
    BeneficiosPorPagina() {
      return PaginacionConstantes.BENEFICIOS_POR_PAGINA;
    },
    /**Dirección de la carpeta de logos */
    CarpetaLogos() {
      return environment.API_URL + Carpetas.LOGOS;
    },
    ColorModa() {
      if (this.categoria) return this.categoria.color;
      else return "var(--color-moda-a)";
    },
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    },
    /**Usado en las imágenes para indicar al servidor que se quiere una miniatura */
    IndicadorMiniatura() {
      return "/mini";
    },
    // Computed properties de vuex
    // Datos compartidos en toda la app
    ...mapState({
      beneficios: (state) => state.beneficios,
      categoria: (state) => state.categoria,
    }),
  },
  watch: {
    busqueda() {
      if (!this.cargaManual) this.cargarPaginasYTarjetas();
    },
    location() {
      this.cargarPaginasYTarjetas();
    },
    subcategoria() {
      this.cargarPaginasYTarjetas();
    },
  },
  methods: {
    // Los métodos con "Evento" adelante son llamados desde afuera, si se cambia su interface, hay que cambiar afuera
    EventoRecargar(busqueda) {
      this.cargarPaginasYTarjetas(busqueda);
    },
    clickBeneficio(beneficio) {
      if (beneficio.habilitado) {
        this.$emit(CLICK_BENEFICIO_EVENT, beneficio);
      }

    },
    /**Usado para cargar o recargar beneficios cuando cambia un filtro
     * También carga la paginacion
     */
    cargarTarjetas(busqueda = this.busqueda) {
      if (this.numeroDePagina > 0 && this.cantidad > 0) {
        this.cargando = true;

        // Parámetros de paginación
        const desde = (this.numeroDePagina - 1) * this.BeneficiosPorPagina + 1;
        const hasta = this.numeroDePagina * this.BeneficiosPorPagina;

        this.service
          .getWithFilter({
            desde,
            hasta,
            busqueda,
            idLocalidad: this.location?.city?.id,
            idProvincia: this.location?.province?.id,
            subcategoria: this.subcategoria?.id,
          })
          .then((response) => {
            this.$store.commit("cargarBeneficios", response.data);
          })
          .finally(() => {
            this.cargando = false;
          });
      } else {
        // No hay beneficios
        this.$store.commit("limpiarBeneficios");
        this.cargando = false;
      }
    },
    cargarPaginasYTarjetas(busqueda = this.busqueda) {
      this.cargando = true;

      this.service
        .countWithFilter({
          busqueda,
          idLocalidad: this.location?.city?.id,
          idProvincia: this.location?.province?.id,
          subcategoria: this.subcategoria?.id,
        })
        .then((respuesta) => {
          this.cantidad = respuesta.data;

          this.numeroDePagina = 1;

          this.cargarTarjetas(busqueda);
        });
    },
    paginaCambiada(numero) {
      this.numeroDePagina = numero;
      this.cargarTarjetas();
      // Scrollear hacia arriba
      Util.scrollearAId("contenedorBeneficios", true);
    },
    // Funcion para adaptar texto dentro de corazon
    fontSizeLabel(palabra) {
      const cantCar = palabra.length;
      let newSizeFont = 100 / cantCar;
      newSizeFont = newSizeFont <= 0 ? 1 : newSizeFont;
      return "max(min(" + newSizeFont + "px, 26px) ,8px)";
    },
  },
  mounted() {
    this.idUsuario = localStorage.getItem("iduser");
    this.token = localStorage.getItem("token");

    if (!this.cargaManual) {
      this.cargarPaginasYTarjetas();
    }
  },
};
</script>
<style scoped>
.contenedor-categoria {
  display: flex;
}

.correccion {
  display: none;
}

.contenedor-individual-card {
  padding: 0 5px 0 5px !important;
  width: 150px !important;
  border-radius: 10px 10px 10px 10px !important;
  cursor: pointer;
}

.opacidad {
  opacity: 0.3;
}

.mostrar {
  opacity: 1;
}

.card-descuento {
  position: relative;
  height: 230px;
  border: 0 !important;
  border-radius: 10px 10px 10px 10px !important;
}

.contenedor-img-desc {
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-direction: column;
  background: gray;
  border-radius: 10px 10px 0 0 !important;
  position: relative;
}

.contenedor-img-desc img {
  border-radius: 10px 10px 0 0;
  width: 100%;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  background-size: cover;
}

.corazon {
  color: var(--color-moda-h);
  font-size: 75px;
  position: absolute;
  z-index: 300;
  display: flex;
  flex-direction: column;
  bottom: 64px;
  height: 75px;
  width: 75px;
}

.corazon h5 {
  position: absolute;
  color: white;
  margin-left: auto;
  margin-right: auto;
  top: 56px;
  font-size: 21px;
  font-family: var(--fuente-din);
  font-style: italic;
  font-stretch: condensed;
  font-weight: 500;
  text-align: center;
  width: 100%;
}

.corazon svg {
  overflow: visible !important;
  position: absolute;
  z-index: -1;
  top: 32px;
}

.sombra-corazon {
  color: #000000;
  opacity: 0.2;
  font-size: 80px;
  position: relative;
  z-index: 250;
  display: flex;
  bottom: 47px;
  left: -2px;
  height: 75px;
  width: 75px;
}

.card-linc-desc {
  height: 60px;
  width: 140px;
  position: absolute;
  left: 0;
  cursor: pointer;
  justify-items: center;
  display: grid;
}

.contenedor-info {
  position: absolute;
  border-radius: 0 0 10px 10px !important;
  z-index: 0;
  background: white;
  width: 140px;
  bottom: 0;
}

.contenedor-info button {
  display: inline-flex;
  flex-direction: column-reverse;
  text-align: center;
  border-radius: 0 0 10px 10px;
  height: 60px;
  z-index: 100;
  width: 140px;
  padding-bottom: 7px;
  align-items: center;
}

.contenedor-info button:hover {
  border-color: inherit;
  text-decoration-color: inherit;
  pointer-events: none;
}

.contenedor-info--hover button:hover {
  pointer-events: visible;
  border-color: rgb(40, 168, 69) !important;
  background: var(--color-estructura-c);
  text-decoration-color: currentcolor;
}

.contenedor-info button .icono {
  position: absolute;
  bottom: 12px;
  right: 20px;
  color: black;
  z-index: 500;
  font-weight: bold;
}

.box-cards-moda {
  display: grid;
  grid-template-columns: repeat(auto-fill, 150px);
  grid-template-rows: 230px;
  align-items: center;
  justify-content: left;
}

.indicador-carga {
  background-color: transparent;
  border: none;
}

.grid-contenedor-moda {
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 200px auto;
  padding-top: 20px;
  background: var(--color-moda-h);
}

#contenedor-paginacion {
  min-height: 100px;
}

/* Extra small devices (portrait phones, less than 576px) */
@media screen and (max-width: 575px) {
  .grid-contenedor-moda {
    grid-gap: 10px;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;
    padding-top: 8px;
    background: var(--color-moda-h);
  }

  .box-cards-moda {
    justify-content: center;
    margin-top: 0px;
  }

  .correccion {
    display: block;
    position: absolute !important;
    z-index: 1000;
    height: 100%;
    width: 3px !important;
    left: 0;
    margin-top: 60px !important;
  }
}
</style>
